import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button} from 'react-bootstrap'
import {connectForm} from '../../core/redux/form'
import ButtonToggle from '../../core/components/ButtonToggle'
import {AGENCY_CRITERIA_UPDATED} from '../actions'
import {AgencyCriteria} from '../models'
import i18n from '../i18n'
import style from './AgencySearch.less'

class AgencySearch extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, form, criteria} = this.props

        return (
        	<div className={style.default}>
                <div className={style.side}>
                    <ButtonToggle
                        {...form.active()}>
                            <Button
                                bsStyle='link'
                                value={true}>
                                <p>{i18n.agencyActive}</p>
                            </Button>
                            <span>|</span>
                            <Button
                                bsStyle='link'
                                value={false}>
                                <p>{i18n.agencyInactive}</p>
                            </Button>
                    </ButtonToggle>
                </div>
        	</div>
        )
    }
}

AgencySearch = connectForm({
    target: 'criteria',
    schema: AgencyCriteria.schema,
    action: AGENCY_CRITERIA_UPDATED
})(AgencySearch)

AgencySearch = connect((state) => ({
    criteria: state.company.agency.criteria
}))(AgencySearch)

export default AgencySearch


// WEBPACK FOOTER //
// ./lib/company/components/AgencySearch.js